var render, staticRenderFns
import script from "./IconSelect.vue?vue&type=script&lang=tsx"
export * from "./IconSelect.vue?vue&type=script&lang=tsx"
import style0 from "./IconSelect.vue?vue&type=style&index=0&id=25a4102a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4102a",
  null
  
)

export default component.exports